(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yoganastix-boyfriend-pilot"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yx-boyfriend-pilot')) {
  customElements.define('yx-boyfriend-pilot', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-yx-config]').textContent);
      this.picker = document.getElementById('variant-selects-' + this.dataset.section);
      this.form = document.getElementById('product-form-' + this.dataset.section);
      this.guard = (event) => {
        if (!this.picker?.querySelector('input[name="Size"]:checked')) {
          event.preventDefault(); event.stopImmediatePropagation();
          this.picker?.querySelector('input[name="Size"]')?.focus();
        }
      };
      this.form?.addEventListener('submit',this.guard,true);
      
      this.fitLink = this.picker?.querySelector('.yx-fit-link');
      this.openFit = (event) => {
        event.preventDefault();
        const fit=document.getElementById('yx-fit-'+this.dataset.section);
        fit.open=true; fit.querySelector('summary').focus();
      };
      this.fitLink?.addEventListener('click',this.openFit);
      this.update = () => {
        const selectedSize=this.picker?.querySelector('input[name="Size"]:checked');
        if (!selectedSize) {
          this.querySelector('[data-yx-dispatch]').textContent=this.config.select;
          this.querySelector('[data-yx-dispatch-property]').disabled=true;
          const button=document.getElementById('ProductSubmitButton-'+this.dataset.section);
          if(button){ button.disabled=true; button.querySelector('span').textContent=this.config.selectSize; }
          return;
        }
        const form = document.getElementById('product-form-' + this.dataset.section);
        const id = form?.querySelector('[name="id"]')?.value || new URL(location.href).searchParams.get('variant');
        const v = this.config.variants.find(item => String(item.id) === String(id));
        const line = this.querySelector('[data-yx-dispatch]');
        if (!v) return;
        this.current = v;
        const standard = ['S','M','L'].includes(v.options[1]);
        line.textContent = !v.available ? this.config.unavailable : standard && v.tracked && v.quantity > 0 ? this.config.ready : this.config.made;
        const dispatchProperty=this.querySelector('[data-yx-dispatch-property]');
        dispatchProperty.value=line.textContent;
        dispatchProperty.disabled=!v.available;
      };
      this.onChange = (event) => { if(event.target.closest('variant-selects')===this.picker || event.target.closest('form')===this.form) this.update(); };
      document.addEventListener('change',this.onChange);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange,this.update);
      this.querySelectorAll('[data-yx-fabric]').forEach(link => link.addEventListener('click',()=>{
        if (this.current) {
          try { sessionStorage.setItem('yx-t101-choice',JSON.stringify({options:this.current.options,expires:Date.now()+60000,target:new URL(link.href).pathname})); } catch(e) {}
        }
      }));
      try {
        const saved=JSON.parse(sessionStorage.getItem('yx-t101-choice')||'null');
        if(saved && saved.expires>Date.now() && saved.target===location.pathname){
          sessionStorage.removeItem('yx-t101-choice');
          const exact=this.config.variants.find(v=>v.options[0]===saved.options[0] && v.options[1]===saved.options[1]);
          const match=exact;
          if(match && new URL(location.href).searchParams.get('variant')!==String(match.id)){
            const url=new URL(location.href); url.searchParams.set('variant',match.id); location.replace(url); return;
          }
        }
      } catch(e) {}
      this.update();
    }
    disconnectedCallback(){document.removeEventListener('change',this.onChange);this.form?.removeEventListener('submit',this.guard,true);this.fitLink?.removeEventListener('click',this.openFit);this.unsubscribe?.();}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yoganastix-shopping-context"] && !Shopify.designMode) return;
  try {
    (() => {
  const source = document.getElementById('yx-shopping-context');
  if (!source) return;
  let base;
  try { base = JSON.parse(source.textContent); } catch { return; }
  const picker = () => document.querySelector('#MainContent .product__info-container variant-selects, #MainContent .product__info-container variant-radios');
  const permitted = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch { return false; }
  };
  let activeSeconds = 0;
  const recentSections = [];
  const snapshot = () => {
    const product = base.product;
    if (!product) return { version: 1, audience: 'retail', page_type: base.page_type, product: null };
    const controls = picker();
    const groups = controls ? [...controls.querySelectorAll('fieldset, select')] : [];
    const values = product.option_names.map((name, index) => {
      const group = groups[index];
      if (!group) return null;
      return group.tagName === 'SELECT' ? group.value : group.querySelector('input:checked')?.value || null;
    });
    const variant = product.variants.find(item => item.options.every((value, index) => value === values[index]));
    const selection = Object.fromEntries(product.option_names.map((name, index) => [name, values[index]]));
    const dispatch = document.querySelector('#MainContent input[name="properties[Dispatch]"]')?.value || null;
    return {
      version: 1, audience: 'retail', page_type: base.page_type,
      product: { id: product.id, handle: product.handle, title: product.title, type: product.type },
      selection, selection_complete: Boolean(variant), variant_id: variant ? String(variant.id) : null,
      displayed_price_minor: variant?.price ?? null, currency: base.currency,
      displayed_dispatch: dispatch,
      ...(permitted() ? { engagement: { active_seconds: activeSeconds, opened_sections: [...recentSections] } } : {}),
      captured_at: new Date().toISOString()
    };
  };
  window.YoganastixContext = Object.freeze({ snapshot });
  const publish = (event, extra = {}) => {
    if (!permitted() || !window.Shopify?.analytics?.publish) return;
    const context = snapshot();
    try {
      const result = window.Shopify.analytics.publish(`yoganastix:${event}`, {
        schema_version: 1, product_id: context.product?.id || null,
        variant_id: context.variant_id || null, selection: context.selection || {}, ...extra
      });
      if (result?.catch) result.catch(() => {});
    } catch {}
  };
  const updateBadge = () => {
    const header = document.querySelector('#n8n-chat .chat-header');
    if (!header) return;
    const root = header.closest('#n8n-chat');
    const panel = root.querySelector('.chat-window');
    const toggle = root.querySelector('.chat-window-toggle');
    const open = Boolean(panel && panel.getClientRects().length);
    if (toggle) {
      toggle.setAttribute('role', 'button');
      toggle.setAttribute('tabindex', '0');
      toggle.setAttribute('aria-label', open ? base.labels.close_chat : base.labels.open_chat);
      toggle.setAttribute('aria-expanded', String(open));
    }
    root.querySelector('textarea')?.setAttribute('aria-label', base.labels.question);
    root.querySelector('.chat-input-send-button')?.setAttribute('aria-label', base.labels.send);
    let badge = header.querySelector('.yx-chat-context');
    if (!badge) {
      badge = document.createElement('p');
      badge.className = 'yx-chat-context';
      badge.setAttribute('role', 'status');
      badge.setAttribute('aria-live', 'polite');
      header.append(badge);
    }
    const context = snapshot();
    const sizeEntry = Object.entries(context.selection || {}).find(([name]) => /size/i.test(name));
    const parts = Object.values(context.selection || {}).filter(Boolean);
    if (sizeEntry && !sizeEntry[1]) parts.push(base.labels.size_unselected);
    const label = context.product ? `${base.labels.viewing} ${context.product.title}${parts.length ? ' · ' + parts.join(' · ') : ''}` : base.labels.general;
    if (badge.textContent !== label) badge.textContent = label;
  };
  let frame;
  const queueBadge = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(updateBadge);
  };
  document.addEventListener('change', event => {
    if (event.target.closest('variant-selects, variant-radios')) {
      queueBadge();
      publish('selection_changed');
    }
  });
  document.addEventListener('toggle', event => {
    if (event.target instanceof HTMLDetailsElement && event.target.open && event.target.closest('.yx-product-details')) {
      const section = event.target.querySelector('summary')?.textContent.trim().slice(0, 60) || '';
      if (permitted()) {
        recentSections.push(section);
        if (recentSections.length > 5) recentSections.shift();
      }
      publish('detail_opened', { section });
    }
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('#n8n-chat .chat-window-toggle')) queueBadge();
  });
  document.addEventListener('keydown', event => {
    if (event.target.matches('#n8n-chat .chat-window-toggle') && ['Enter', ' '].includes(event.key)) {
      event.preventDefault();
      event.target.click();
    }
  });
  let seenChat = false;
  const observeChat = () => {
    const chat = document.getElementById('n8n-chat');
    if (!chat) return false;
    chat.setAttribute('data-clarity-mask', 'True');
    new MutationObserver(() => {
      queueBadge();
      const panel = chat.querySelector('.chat-window');
      const open = Boolean(panel && panel.getClientRects().length);
      if (open && !seenChat) publish('chat_opened');
      seenChat = open;
    }).observe(chat, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    updateBadge();
    return true;
  };
  if (!observeChat()) {
    const boot = new MutationObserver(() => { if (observeChat()) boot.disconnect(); });
    boot.observe(document.body, { childList: true });
  }
  let lastInteraction = Date.now();
  const emitted = new Set();
  ['pointerdown', 'keydown', 'scroll'].forEach(name => document.addEventListener(name, () => { lastInteraction = Date.now(); }, { passive: true }));
  setInterval(() => {
    if (!permitted() || document.visibilityState !== 'visible' || Date.now() - lastInteraction > 60000) return;
    activeSeconds += 5;
    [30, 60, 120].forEach(seconds => {
      if (activeSeconds >= seconds && !emitted.has(seconds)) {
        emitted.add(seconds);
        publish('engaged_time', { seconds });
      }
    });
  }, 5000);
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
})();
  } catch(e) { console.error(e); }
})();

})();
